import { AppAction } from "@core/types/redux.type";
import { ExamAttemptActionType, ExamAttemptState } from "./exam-attempt.type";

const initialState: ExamAttemptState = {
  currentAttemptId: null,
};

export default function examAttemptReducer(
  state = initialState,
  action: AppAction
): ExamAttemptState {
  switch (action.type) {
    case ExamAttemptActionType.SET_CURRENT_ATTEMPT:
      return {
        ...state,
        currentAttemptId: action.payload?.attemptId,
      };
    case ExamAttemptActionType.CLEAR_CURRENT_ATTEMPT:
      return initialState;
    default:
      return state;
  }
}
